<template>
  <CreateUpdateTemplate :routePreventDialog="routePreventDialog" :hasChanges="hasChanges"
    :customClass="'property-create create-form'"
    v-if="getPermission('engineer:create') || getPermission('engineer:update')">
    <template v-slot:header-title>
      <div class="d-flex">
        <h1 class="form-title text-truncate">
          Payroll For
          <span class="form-title-create-link orange--text" link>{{
            customerObject?.display_name
          }}</span>
        </h1>
        <v-chip label v-if="barcode" color="chip-custom-blue" outlined class="text-white p-3 ml-4"
          style="font-size: 21px !important; font-weight: 700">
          <template>
            {{ barcode }}
          </template>
        </v-chip>
      </div>
    </template>
    <template v-slot:header-action>
      <v-btn depressed v-on:click="goBack" :disabled="pageLoading" class="mx-2 custom-grey-border custom-bold-button">
        Cancel
      </v-btn>
      <v-btn depressed :disabled="!formValid || pageLoading" :loading="pageLoading"
        class="mx-2 custom-bold-button white--text" v-on:click="onSubmit" color="cyan">
        {{ getAction }} Payroll
      </v-btn>
    </template>
    <template v-slot:body>
      <v-form ref="payrollForm" v-model.trim="formValid" lazy-validation v-on:submit.stop.prevent="onSubmit">
        <v-row class="white-background create-property-height">
          <v-container fluid>
            <v-row>
              <v-col md="4" class="ml-4">
                <label class="font-size-16 font-weight-500 required" for="y-salutation">
                  Payroll dates</label>
                <template v-if="pageLoading">
                  <v-skeleton-loader class="custom-skeleton height-90px custom-skeleton-full-width" width="500"
                    type="text">
                  </v-skeleton-loader>
                </template>
                <v-menu v-else v-model="datePicker" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field dense filled flat label="Payroll Dates" hide-details solo :loading="pageLoading"
                      :disabled="pageLoading" clearable prepend-inner-icon="mdi-calendar" @click:clear="clearDates"
                      :rules="[
                        validateRules.required(payrollDates, 'Payroll Dates'),
                      ]" readonly v-bind="attrs" v-on="on" :value="formattedPayrollDates" class="required"
                      color="cyan"></v-text-field>
                  </template>
                  <v-date-picker color="cyan" range :disabled="pageLoading" v-if="isReady" placeholder="Data Range"
                    v-model="payrollDates" type="month" multiple :rules="[
                      validateRules.required(payrollDates, 'Payroll Dates'),
                    ]" class="required">
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="10">
                <template v-if="pageLoading">
                  <v-skeleton-loader class="custom-skeleton height-90px custom-skeleton-full-width mt-3 ml-4"
                    width="500" type="card">
                  </v-skeleton-loader>
                </template>
                <v-card v-else flat class="custom-grey-border remove-border-radius mt-3 ml-4" style="width: 50%">
                  <v-card-title class="grey lighten-4">
                    <span class="text-h6 font-weight-bold color-custom-blue">Work Details</span>
                  </v-card-title>

                  <v-card-text class="pa-4">
                    <v-row class="mb-2" dense>
                      <v-col cols="6">
                        <div class="d-flex align-center">
                          <span class="text-subtitle-1 font-weight-medium">No. of Jobs:</span>
                          <v-chip style="margin-left: 10px" color="cyan lighten-4" text-color="black" small>
                            {{ payrollArr.total_jobs }}
                          </v-chip>
                        </div>
                      </v-col>

                      <v-col cols="6">
                        <div class="d-flex align-center">
                          <span class="text-subtitle-1 font-weight-medium">Extra Jobs:</span>
                          <v-chip style="margin-left: 10px" color="cyan lighten-4" text-color="black" small>
                            {{ payrollArr.total_jobs > 40 ? extra_job : 0 }}
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="6">
                        <div class="d-flex align-center">
                          <span class="text-subtitle-1 font-weight-medium">Total Hours:</span>
                          <v-chip style="margin-left: 10px" color="cyan lighten-4" text-color="black" small>
                            {{ payrollArr.total_hours }}
                          </v-chip>
                        </div>
                      </v-col>

                      <v-col cols="6">
                        <div class="d-flex align-center">
                          <span class="text-subtitle-1 font-weight-medium">OT Hours:</span>
                          <v-chip style="margin-left: 15px" color="cyan lighten-4" text-color="black" small>
                            {{ payrollArr.total_hours > 176 ? extra_hours : 0 }}
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense v-if="payrollArr.skip_hours > 0">
                      <v-col cols="6">
                        <div class="d-flex align-center">
                          <span class="text-subtitle-1 font-weight-medium">Skip Hours:</span>
                          <v-chip style="margin-left: 10px" color="cyan lighten-4" text-color="black" small>
                            {{ payrollArr.skip_hours }}
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <!-- Salary Details -->

                <v-card flat class="custom-grey-border remove-border-radius mt-3 ml-4">
                  <v-card-title class="headline grey lighten-4">
                    <h3 class="font-weight-700 custom-headline color-custom-blue">
                      <h3 class="text-h5 font-weight-bold">Salary Details</h3>
                    </h3>
                  </v-card-title>

                  <div class="pa-8 elevation-2">
                    <v-row class="align-center mb-4">
                      <v-col cols="6">
                        <label class="text-subtitle-2 font-weight-bold">Salary Type</label>
                        <div class="d-flex justify-end">
                          <v-icon small @click="SalaryTypeData" class="ml-3">mdi-cog</v-icon>
                        </div>
                        <template v-if="pageLoading">
                          <v-skeleton-loader class="custom-skeleton height-10px custom-skeleton-full-width" type="text">
                          </v-skeleton-loader>
                        </template>
                        <v-select v-else :items="options.salaryType" v-model="payrollArr.salary_type" dense filled solo
                          clearable flat color="cyan" item-text="type" item-value="type" placeholder="Salary Type" />
                      </v-col>
                    </v-row>

                    <v-row class="align-center mb-4">
                      <v-col cols="6">
                        <label class="text-subtitle-2 font-weight-bold">Basic</label>
                        <template v-if="pageLoading">
                          <v-skeleton-loader class="custom-skeleton height-10px custom-skeleton-full-width" type="text">
                          </v-skeleton-loader>
                        </template>
                        <v-text-field v-else v-model="payrollArr.basic" type="number" dense filled solo flat
                          color="cyan" prefix="$" :rules="[
                            validateRules.decimalValidation(
                              payrollArr.basic,
                              'Basic'
                            ), validateRules.maxLength(payrollArr.basic, 'Basic', 7),
                          ]" />
                      </v-col>
                      <v-col cols="6">
                        <label class="text-subtitle-2 font-weight-bold">Housing Allowance</label>
                        <template v-if="pageLoading">
                          <v-skeleton-loader class="custom-skeleton height-10px custom-skeleton-full-width" type="text">
                          </v-skeleton-loader>
                        </template>
                        <v-text-field v-else v-model="payrollArr.housing_allowance" type="number" dense filled solo flat
                          color="cyan" :rules="[
                            validateRules.decimalValidation(
                              payrollArr.housing_allowance,
                              'Housing Allowance'
                            ),validateRules.maxLength(payrollArr.housing_allowance, 'Housing Allowance', 7),
                          ]" prefix="$" />
                      </v-col>
                    </v-row>

                    <v-row class="align-center mb-4">
                      <v-col cols="6">
                        <label class="text-subtitle-2 font-weight-bold">Transportation Allowance</label>
                        <template v-if="pageLoading">
                          <v-skeleton-loader class="custom-skeleton height-10px custom-skeleton-full-width" type="text">
                          </v-skeleton-loader>
                        </template>
                        <v-text-field v-else v-model="payrollArr.transport_allowance" type="number" dense filled solo
                          flat color="cyan" :rules="[
                            validateRules.decimalValidation(
                              payrollArr.transport_allowance,
                              'Transportation Allowance'
                            ),validateRules.maxLength(payrollArr.transport_allowance, 'Housing Allowance', 7),
                          ]" prefix="$" />
                      </v-col>
                      <v-col cols="6">
                        <label class="text-subtitle-2 font-weight-bold">Phone Allowance</label>
                        <template v-if="pageLoading">
                          <v-skeleton-loader class="custom-skeleton height-10px custom-skeleton-full-width" type="text">
                          </v-skeleton-loader>
                        </template>
                        <v-text-field v-else v-model="payrollArr.phone_allowance" type="number" dense filled solo flat
                          color="cyan" :rules="[
                            validateRules.decimalValidation(
                              payrollArr.phone_allowance,
                              'Phone Allowance'
                            ),validateRules.maxLength(payrollArr.phone_allowance, 'Housing Allowance', 7),
                          ]" prefix="$" />
                      </v-col>
                    </v-row>

                    <v-row class="align-center mb-4">
                      <v-col cols="6">
                        <label class="text-subtitle-2 font-weight-bold">OT Pay</label>
                        <template v-if="pageLoading">
                          <v-skeleton-loader class="custom-skeleton height-10px custom-skeleton-full-width" type="text">
                          </v-skeleton-loader>
                        </template>
                        <v-text-field v-else v-model="payrollArr.overtime_pay" type="number" dense filled solo flat
                          color="cyan" :rules="[
                            validateRules.decimalValidation(
                              payrollArr.overtime_pay,
                              'OT Pay'
                            ),validateRules.maxLength(payrollArr.overtime_pay, 'Housing Allowance', 7),
                          ]" prefix="$" />
                      </v-col>
                      <v-col cols="6">
                        <label class="text-subtitle-2 font-weight-bold">Job Incentives</label>
                        <template v-if="pageLoading">
                          <v-skeleton-loader class="custom-skeleton height-10px custom-skeleton-full-width" type="text">
                          </v-skeleton-loader>
                        </template>
                        <v-text-field v-else v-model="payrollArr.job_incentives" type="number" dense filled solo flat
                          color="cyan" :rules="[
                            validateRules.decimalValidation(
                              payrollArr.job_incentives,
                              'Job Incentives'
                            ),validateRules.maxLength(payrollArr.job_incentives, 'Housing Allowance', 7),
                          ]" prefix="$" />
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-form>
      <ManageSalaryType :b-dialog="manageSalaryTypeDialog" :salaryType="options.salaryType"
        v-on:close-dialog="manageSalaryTypeDialog = false" v-on:get-service-type="getOptions">
      </ManageSalaryType>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  QUERY,
  PUT,
  CLEAR_ERROR,
  POST,
  GET,
} from "@/core/services/store/request.module";
import PropertyMixin from "@/core/plugins/property-mixin";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import ManageSalaryType from "@/view/pages/partials/Manage-Salary-Type.vue";
// import CustomerDialog from "@/view/pages/partials/Select-Customer.vue";
import { ErrorEventBus } from "@/core/lib/message.lib";
// import { mapGetters } from "vuex";
// import { GmapMap } from "vue2-google-maps";
export default {
  mixins: [CommonMixin, PropertyMixin, ValidationMixin],
  name: "property-create",
  title: "Create Payroll",
  data() {
    return {
      payrollDates: [],
      payrollArr: {
        payroll_start_date: null,
        payroll_end_date: null,
        cleaner_id: null,
        salary_type: null,
        basic: null,
        housing_allowance: null,
        transport_allowance: null,
        phone_allowance: null,
        status: null,
        overtime_pay: null,
        job_incentives: 0,
        total_hours: 0,
        total_jobs: 0,
        skip_hours: 0,
      },

      pageLoading: false,
      isReady: true,
      manageSalaryTypeDialog: false,
      // total_hours: 0,
      // total_jobs: 0,
      extra_hours: 0,
      monthDiff: 0,
      extra_job: 0,
      property: 0,
      propertyArr: {},
      barcode: null,
      payroll: 0,
      customerObject: {},
      notification: {},
      options: {
        salaryType: null,
      },
      propertyTab: null,
    };
  },
  components: {
    CreateUpdateTemplate,
    ManageSalaryType,
  },
  watch: {
    formValid(param) {
      if (param) {
        this.$store.dispatch(CLEAR_ERROR, {});
      }
    },
    payroll(param) {
      if (param > 0) {
        this.getPayroll()
          .then((response) => {
            this.payrollArr = response;
            this.payrollDates = this.payrollArr?.payrollDates;
            this.isReady = true;
            this.pageLoading = true;
            this.getJobData(this.payrollDates);
          })
          .catch((error) => {
            this.logError(error);
            this.$router.go(-1);
          })
          .finally(() => {
            this.pageLoading = false;
          });
      }
    },
    payrollDates(val) {
      if (val && val[0]) {
        this.getJobData(val);
        this.getMonthDiff(val);
      }
    },
  },
  methods: {
    getMonthDiff(date) {
      let sy, sm, ey, em;
      if (date[0]) {
        [sy, sm] = date[0].split("-").map(Number);
      }
      if (date[1]) {
        [ey, em] = date[1].split("-").map(Number);
      } else {
        ey = sy;
        em = sm;
      }

      this.monthDiff = (ey - sy) * 12 + (em - sm) + 1;
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(-2);
      return `${day}-${month}-${year}`;
    },
    selectCleaner(cleaner) {
      if (cleaner > 0) {
        this.hasChanges = false;
        this.$router
          .replace(
            this.getDefaultRoute("payroll.create", {
              query: { cleaner },
            })
          )
          .then(() => {
            window.location.reload(true);
          });
      }
    },
    getOptions() {
      const _this = this;

      let data = {
        engineer: _this.cleaner,
      };
      _this.$store
        .dispatch(QUERY, { url: "payroll/options", data })
        .then(({ data }) => {
          _this.customerObject = data?.cleaner;
          _this.options.salaryType = data?.salary_type;
          if (data && data.basic_pay) {
            this.payrollArr.basic = data.basic_pay ?? null;
          }
          if (data && data.housing_allowance) {
            this.payrollArr.housing_allowance = data.housing_allowance ?? null;
          }
          if (data && data.phone_allowance) {
            this.payrollArr.phone_allowance = data.phone_allowance ?? null;
          }
          if (data && data.transport_allowance) {
            this.payrollArr.transport_allowance =
              data.transport_allowance ?? null;
          }
          _this.payrollArr.basic = _this.payrollArr.basic * this.monthDiff;
          _this.payrollArr.housing_allowance = _this.payrollArr.housing_allowance * this.monthDiff;
          _this.payrollArr.phone_allowance = _this.payrollArr.phone_allowance * this.monthDiff;
          _this.payrollArr.transport_allowance = _this.payrollArr.transport_allowance * this.monthDiff;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    onSubmit() {
      const _this = this;
      if (!_this.$refs.payrollForm.validate()) {
        return false;
      }

      if (!_this.payrollDates) {
        ErrorEventBus.$emit("update:error", "Please enter Payrolls dates.");
      }
      const startDates = this?.payrollDates.map((month) => `${month}-01`);
      _this.payrollArr.payroll_start_date = startDates[0];
      _this.payrollArr.payroll_end_date = startDates[1];
      _this.payrollArr.cleaner = _this.cleaner;
      _this.$store
        .dispatch(PUT, {
          url: "payroll/",
          data: { payroll: _this.payrollArr },
        })
        .then((response) => {
          _this.propertyCreated = true;
          _this.$nextTick(() => {
            _this.$router.push(
              _this.getDefaultRoute("payroll.detail", {
                params: { id: response?.data?.id },
                query: { status: "active" },
              })
            );
          });
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
      // }
    },
    getPayroll() {
      const _this = this;
      _this.isReady = false;
      _this.pageLoading = true;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(GET, { url: "payroll/" + _this.payroll })
            .then((response) => {
              resolve(response.data);
              _this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Payroll", route: "property" },
                { title: "Update" },
              ]);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    clearDates() {
      const _this = this;
      _this.payrollArr.payroll_start_date = null;
      _this.formattedPayrollDates = [];
      _this.payrollDates = [];
      _this.monthDiff = 0;
      _this.payrollArr.payroll_end_date = null;
      _this.payrollArr.total_jobs = 0;
      _this.payrollArr.total_hours = 0;
      _this.payrollArr.extra_hours = 0;
      _this.payrollArr.extra_job = 0;
      _this.payrollArr.skip_hours = 0;

      // }
    },
    getJobData(val) {
      if (!val) {
        return false;
      }
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch(POST, {
            url: "get-total-job-hours",
            data: {
              dates: val,
              cleaner_id: this.cleaner,
            },
          })
          .then((response) => {
            this.updateOvertime(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    SalaryTypeData() {
      this.manageSalaryTypeDialog = true;
      this.getOptions();
    },
    updateOvertime(response) {
      const _this = this;
      this.getOptions();
      if (response) {
        _this.payrollArr.total_jobs =
          response.total_jobs > 0 ? response.total_jobs : 0;
        _this.payrollArr.total_hours =
          response.total_hours > 0 ? response.total_hours : 0;
        _this.payrollArr.skip_hours =
          response.total_skip_hours > 0 ? response.total_skip_hours : 0;
        _this.extra_hours =
          response.total_hours > 176 * this.monthDiff
            ? response.total_hours - 176 * this.monthDiff
            : 0;


        _this.extra_job = response.total_jobs > 40 * this.monthDiff
          ? response.total_jobs - 40 * this.monthDiff
          : 0;
        if (!_this.payrollArr?.id) {


          _this.payrollArr.overtime_pay =
            _this.extra_hours > 0 ? this.extra_hours * 6 : 0;
          _this.payrollArr.job_incentives =
            _this.extra_job > 0 ? this.extra_job * 10 : 0;
        }
      }
    },
  },
  mounted() {
    const _this = this;
    _this.getOptions();
    _this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Payroll", route: "payroll" },
      { title: "Create" },
    ]);
    if (_this.payroll === 0) {
      _this.isReady = true;
    } else {
      _this.isReady = false;
    }
  },
  created() {
    const _this = this;
    _this.payroll = _this.lodash.toSafeInteger(_this.$route.params.id);
    _this.cleaner = _this.lodash.toSafeInteger(_this.$route.query.cleaner);
    if (_this.customer <= 0) {
      _this.$router.go(-1);
    }
  },
  computed: {
    getAction() {
      if (this.payroll) {
        return "Update";
      }
      return "Save";
    },
    getPropertyTitle() {
      const _this = this;
      if (_this.propertyArr && _this.propertyArr.barcode) {
        return " • " + _this.propertyArr.barcode;
      }
      return "";
    },
    formattedPayrollDates: {
      get() {
        if (!this.payrollDates || this.payrollDates.length === 0) return "";
        return this.payrollDates
          .map((date) =>
            new Date(date + "-01").toLocaleString("default", {
              month: "short",
              year: "numeric",
            })
          )
          .join(' - ');
      },
      set() {
        // const monthMap = {
        //   Jan: '01', Feb: '02', Mar: '03', Apr: '04',
        //   May: '05', Jun: '06', Jul: '07', Aug: '08',
        //   Sep: '09', Oct: '10', Nov: '11', Dec: '12'
        // };
        // this.payrollDates = val
        //   .split(',')
        //   .map(part => part.trim().split(' '))
        //   .map(([mon, year]) => `${year}-${monthMap[mon]}`);
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.propertyCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>
<style>
.v-picker__title {
  display: none !important;
}
</style>
